module.exports = __webpack_public_path__ + "img/grand.79a170bc.svg";